import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import { useRef } from "react";
import ModalPop from "./ModalPop";

const Emergency = () => {
  const phoneList = [
    "/images/phone1.webp",
    "/images/phone2.webp",
    "/images/phone3.webp",
    "/images/phone4.webp",
    "/images/phone5.webp",
    "/images/phone6.webp",
    "/images/phone7.webp",
    "/images/phone8.webp",
    "/images/phone9.webp",
  ];

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <div
      id="emergency"
      className=" relative w-full h-full px-[calc((100%-var(--container))/2)] 3xl:px-[calc((100%-var(--container)-100px))] mb-8 lg:mb-0 pt-8 lg:pt-16 2xl:pt-32 overflow-hidden"
    >
      <p className="text-[#9E9E9E] mb-10 lg:mb-16">03. 긴급출동 서비스</p>
      <div className=" absolute top-10 lg:top-24 right-1/2 lg:-translate-x-32">
        <img src="/images/circle.png" alt="장식용 원형 이미지" width={60} height={60} />
      </div>
      <div className=" absolute top-48 right-1/3 lg:translate-x-10">
        <img src="/images/circle.png" alt="장식용 원형 이미지" width={240} height={240} />
      </div>
      <div className=" absolute bottom-52 left-28">
        <img src="/images/circle.png" alt="장식용 원형 이미지" width={120} height={120} />
      </div>
      <div className=" relative w-full h-full lg:grid xl:grid-cols-2 gap-10 lg:gap-10">
        <div className=" relative w-full h-full mb-10">
          <div className="xl:col-span-2 text-black">
            <h2 className="gmedium font-light leading-8 text-[35px] md:text-[42px] lg:text-[55px] 2xl:mb-1 2xl:text-6xl">
              365일&nbsp;24시간
            </h2>
            <h2 className="manru text-[35px] md:text-[42px] lg:text-[55px] 2xl:text-6xl font-light text-secondary">
              출장방문&nbsp;서비스
            </h2>
            <div className=" px-5 my-5 lg:my-10 3xl:my-16 text-font">
              <p className="text-xl">도어락 · 열쇠로 인해</p>
              <p className="text-xl">새벽에 갑자기 문제가 생기셨나요?</p>
            </div>
          </div>
          <div className=" relative w-full h-fit bg-white rounded-lg py-4 px-3 lg:p-6 max-w-[500px]">
            <button
              type="button"
              onClick={() => window.open("tel:010-9287-9477")}
              className=" relative w-full h-auto my-3"
            >
              <img
                className=" relative w-full h-auto object-contain"
                src="/images/num.png"
                alt="number"
                width={1189}
                height={107}
              />
            </button>
            <div className=" border-l-4 border-primary lg:ml-3 pl-3 text-[var(--gray-color)] my-4">
              <p className="leading-tight">
                새벽시간대에는 문자상담보다는 전화상담!
              </p>
              <p className="">
                문자문의 후 30분 이내에 답이 없다면 꼭 전화주세요!
              </p>
              <p className="text-primary text-xs">
                (작업중에는 소음이 심해 문자알림을 못들을 수 있습니다)
              </p>
            </div>
            <button
              type="button"
              onClick={openfunc}
              className=" absolute -bottom-4 right-5 w-fit h-fit bg-point rounded-lg border border-black px-5 py-1"
            >
              <p>출장방문 요청 바로가기</p>
            </button>
          </div>
        </div>
        <div
          data-aos="fade-up"
          className=" relative w-full h-full pb-10 pt-10 lg:pt-0"
        >
          <div className=" absolute -bottom-56 lg:-bottom-72 w-full">
            <img
              className="!relative w-full h-auto object-contain"
              src="/images/whiteCircle.png"
              alt="icon"
              width={1039}
              height={1039}
            />
          </div>
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            effect={"fade"}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            loop={true}
            navigation={false}
            modules={[Autoplay, EffectFade]}
            className="mySwiper relative w-full h-full"
          >
            {phoneList.map((v, i) => (
              <SwiperSlide key={i}>
                <div className=" relative w-full h-full">
                  <img
                    className="w-auto h-full object-contain max-h-[480px] lg:max-h-[620px] 3xl:max-h-[700px] mx-auto"
                    src={v}
                    alt="phone"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
    </div>
  );
};

export default Emergency;
